import * as React from 'react';
import Base from './Base';
var Paragraph = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Base, Object.assign({
    ref: ref
  }, props, {
    component: "div"
  }));
});
export default Paragraph;